module.exports = __webpack_public_path__ + "img/activity_coupon1.7430789f.png";